import { css } from '@emotion/react';

import { colors, fontWeight } from '~/styles/constants';

export const dateRangePopperStyle = css`
  .react-datepicker {
    font-size: 14px;
    border-radius: 0;
    border: 1px solid ${colors.form.greyBorder};
  }

  .react-datepicker__header {
    background: none;
    border-bottom: none;
  }

  .react-datepicker__navigation {
    top: 0.6rem;
  }

  .react-datepicker__month-container {
    padding: 0.3rem 0.3rem 1rem;
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__current-month {
    margin-bottom: 0.8rem;
  }

  .react-datepicker__day-name {
    color: #3d5560;
    font-weight: ${fontWeight.medium};
    font-size: 12px;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    background: ${colors.forest700};
    color: #000;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range:hover {
    background: ${colors.forest700};
    color: ${colors.white};
  }

  .react-datepicker__day--selected:hover,
  .react-datepicker__day--in-range:hover {
    background: ${colors.forest700};
  }

  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
    background: ${colors.forest200};
  }

  .react-datepicker__navigation-icon::before {
    border-color: #000;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    background-color: ${colors.forest700};
    color: white;
    font-weight: ${fontWeight.medium};
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected:hover {
    background-color: ${colors.forest700};
  }
`;
